import React from "react";

interface AdminCounterProps {
  label: string;
  value: number;
  min: number;
  max: number;
  disabled?: boolean;
  onChangeRequested: (next: number) => Promise<void>;
}

export default function AdminCounter({ label, value, min, max, disabled = false, onChangeRequested }: AdminCounterProps) {
  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const parsed = parseInt(raw || "0", 10);
    if (Number.isNaN(parsed)) return;
    const bounded = Math.max(min, Math.min(max, parsed));
    try {
      await onChangeRequested(bounded);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <strong>{label}:</strong>
      <input
        type="number"
        value={value}
        min={min}
        max={max}
        step={1}
        disabled={disabled}
        onChange={handleChange}
        style={{
          width: "70px",
          padding: "0.25rem 0.4rem",
          fontSize: "0.85rem",
          border: "1px solid #ced4da",
          borderRadius: "4px",
          color: "#212529",
          backgroundColor: disabled ? "#f1f3f5" : "white",
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? "not-allowed" : "text"
        }}
      />
    </label>
  );
}


